import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Hospital bitwerx';
export const hospitalBirwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'hospitalBitwerx',
  endpoints: (build) => ({
    updateHospital: build.mutation<any, any>({
      invalidatesTags: [tagType],
      transformResponse: (response: any) => response,
      query: (data: any) => ({
        data,
        method: 'post',
        url: URL.ASSIGN_BITWERX,
      }),
    }),
    deleteHospital: build.mutation<any, any>({
      invalidatesTags: [tagType],
      transformResponse: (response: any) => response,
      query: (data: any) => ({
        method: 'post',
        url: URL.UNASSIGN_BITWERX,
        data: { hospital_id: data.id, pms_type: data.pms_type },
      }),
    }),
    getHospital: build.query<any[], any>({
      providesTags: [tagType],
      transformResponse: (response: any) => {
        return response.data;
      },
      query: (data: any) => {
        return {
          method: 'get',
          url: `${URL.CHECK_BITWERX_PRACTICES}/${data.id}`,
        };
      },
    }),
    get: build.query<any[], { pms_type?: string; hospital_id?: string }>({
      providesTags: [tagType],
      transformResponse: (response: any) => response.data,
      query: (params) => {
        const queryParams: string[] = [];
        if (params.pms_type) {
          queryParams.push(`pms_type=${params.pms_type}`);
        }
        if (params.hospital_id) {
          queryParams.push(`hospital_id=${params.hospital_id}`);
        }
        const url =
          queryParams.length > 0
            ? `${URL.BITWERX_PRACTICES}?${queryParams.join('&')}`
            : URL.BITWERX_PRACTICES;
        return {
          url,
          method: 'get',
        };
      },
    }),
  }),
});
export const {
  useGetQuery,
  useGetHospitalQuery,
  useDeleteHospitalMutation,
  useUpdateHospitalMutation,
} = hospitalBirwerxApi;
